import React from 'react';

const TimePreviewer: React.FC = () => {
    return (
        <div className="w-full h-full flex items-center justify-center p-2">
            <div className="text-center font-mono w-full" style={{ fontSize: 'clamp(8px, 1.5vw, 14px)' }}>
                {new Date().toLocaleTimeString()}
            </div>
        </div>
    );
};

export default TimePreviewer;
